@let showInsuranceTerms =
	recordData().premiumPeriod ||
	recordData().excessAmount ||
	recordData().insuredValue ||
	recordData().coverageType ||
	recordData().coverageType;

<app-section-wrapper-container>
	<div class="overview-sub-section">
		<app-summary-brief
			class="bg-gradient-to-r from-gray-600 via-gray-500 to-slate-400 border border-gray-400"
			[svgIcon]="
				recordCategories | getIconFromOptions: this.recordData().recordCategory
			"
			[title]="'vehicle-insurances|title'"
			[value]="
				this.recordData().recordCategory
					| getTranslationKeyFromValue: recordCategories
					| transloco
			">
			<div class="flex flex-col gap-4">
				<div
					class="flex flex-col sm:flex-row gap-2 items-start md:items-center px-2">
					<app-date-range-pill
						class="-ml-2 text-white"
						[startsAt]="isoDateFrom()"
						[endsAt]="isoDateTo()" />
					<app-expires-at-pill
						class="text-white"
						[endsAt]="recordData()?.endsAt?.toISOString()" />
				</div>
				@if (recordData().externalReference) {
					<div class="brief-item">
						<app-summary-item
							forceWhiteText
							[title]="
								'road-taxes|record|details-section|field-label|external-reference'
							"
							[value]="recordData().externalReference" />
					</div>
				}
			</div>
		</app-summary-brief>
	</div>

	@if (showInsuranceTerms) {
		<div class="overview-sub-section">
			@if (recordData().premiumPeriod) {
				<app-summary-item
					[title]="
						'vehicle-insurances|record|details-section|field-label|premium-period'
					"
					[value]="
						recordData().premiumPeriod
							| getTranslationKeyFromValue: premiumPeriods
							| transloco
					" />
			}

			@if (recordData().excessAmount) {
				<app-summary-item
					[title]="
						'vehicle-insurances|record|details-section|field-label|excess-amount'
					"
					[value]="recordData().excessAmount" />
			}

			@if (recordData().insuredValue) {
				<app-summary-item
					[title]="
						'vehicle-insurances|record|details-section|field-label|insured-value'
					"
					[value]="recordData().insuredValue" />
			}

			@if (recordData().coverageType) {
				<app-summary-item
					[title]="
						'vehicle-insurances|record|details-section|field-label|coverage-type'
					"
					[value]="
						recordData().coverageType
							| getTranslationKeyFromValue: coverageTypes
							| transloco
					" />
			}

			@if (recordData().totalLossPercentage) {
				<app-summary-item
					[title]="
						'vehicle-insurances|record|details-section|field-label|total-loss-percentage'
					"
					[value]="recordData().totalLossPercentage" />
			}
		</div>
	}

	<div class="flex gap-4 flex-col md:flex-row">
		@if (recordData().vehicleId) {
			<app-vehicle-link-card [id]="recordData().vehicleId" />
		}
	</div>
	@if (!isNew) {
		<app-module-selector
			[nav]="nav()"
			[isNew]="isNew"
			[recordId]="recordData().id" />
	}
</app-section-wrapper-container>
